import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const perks = ['Download immediato', 'Pagamento unico', 'Accesso a vita', 'Garanzia 7 giorni'];
type OfferBlockProps = {
  showPerks?: boolean;
  showCurrencyNote?: boolean;
};
export function OfferBlock({
  showPerks = true,
  showCurrencyNote = true
}: OfferBlockProps) {
  return <div className="w-full space-y-3" data-id="element-40" data-mp="skb5jvadt7nm">
      <Countdown data-id="element-41" data-mp="slcqcrh798ij" />
      <ScarcityBar data-id="element-42" data-mp="smxdhw16pp6d" />

      {showPerks ? <ul className="grid grid-cols-2 gap-x-3 gap-y-2" data-id="element-43" data-mp="wl3dml7ip6ib">
          {perks.map(perk => <li key={perk} className="flex items-start gap-1.5 text-[12px] leading-snug text-white/70 sm:text-sm" data-id="element-44" data-mp="ivjgbuwph1ge">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-45" data-mp="nsjme5tk247i" />
              {perk}
            </li>)}
        </ul> : null}

      {showCurrencyNote ? <p className="text-center text-[11px] leading-snug text-white/40 sm:text-xs" data-id="element-46" data-mp="1gaxa3cl6g9sv">
          💱 La conversione della valuta viene effettuata automaticamente in base al tuo Paese.
        </p> : null}
    </div>;
}